module.exports = __webpack_public_path__ + "img/6-2.5344b8db.png";